import * as React from 'react';
import { defaultTableMultiBody, tableMultiBodyContext } from './context';
export var TableMultiBodyContextProvider = function (props) {
    var _a = props.multiBody, multiBody = _a === void 0 ? defaultTableMultiBody : _a, children = props.children;
    return (React.createElement(tableMultiBodyContext.Provider, { value: multiBody }, children));
};
